/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="wrapp-page-login">
    <div class="block-content">
      <div class="block-content__body">
        <div class="image-background" v-lazy:background-image="backgroundImage"></div>
        <div class="wrapp-content">
          <div class="column-panel left-column">
            <div class="box-text">
              <div class="wrapp-icon">
                <svg class="o-icon"><use xlink:href="#logo-viewide"></use></svg>
              </div>
              <div class="wrapp-intro">
                <p>Benvenuti nell’app servizi di COIN</p>
              </div>
              <div class="wrapp-footer">
                <p>All Rights reserved. Bcame S.r.L {{currentYear}}</p>
              </div>
            </div>
          </div>
          <div class="column-panel right-column">
            <div class="box-login">
              <div class="wrapp-intro wrapp-title-deprecated">
                Attenzione: è necessario scaricare una nuova versione della app.  <br>
                Cliccare <a class="link-new-app" target="_blank" @click="openUrl">qui</a> per procedere
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BrandLogo from 'theme/components/BrandLogo/BrandLogo'

export default {
  name: 'Redirect',
  data () {
    return {
      backgroundImage: require('theme/assets/image/login-bg.jpg'),
      currentYear: new Date().getFullYear(),
      urlNewApp: process.env.NODE_ENV === 'production' ? 'https://viewide.coin.it' : 'https://viewide-salesforce.bcame.it'
    }
  },
  methods: {
    openUrl () {
      window.open(this.urlNewApp)
    }
  },
  components: {
    BrandLogo
  }
}
</script>

<style scoped>
  .link-new-app:hover {
    cursor: pointer;
  }
  .wrapp-title-deprecated {
    font-size: 2rem;
  }
  .link-new-app {
    text-decoration: underline;
    font-weight: bold;
  }
</style>
